import { post } from "@/utils/utils";

const activityCenter = {
  state: {
    activityCenterList: {},
    activityCenterAllList: {},
    editActivity: {},
    detailActivity: {},
    myActivityList: {
      stateCount: {
        ongoingCount: 0
      },
      pageList: {
        records: []
      }
    },
    gameTypeList: {},
    allGameTypeList: {},
    winningList: {},
    collectCardWinningList: {},
    allCollectCardWinningList: {},
    allWinningList: {},
    detailAct: {},
    teamOrderList: {},
    detailsTeamOrder: {
      goodsInfo: {},
      orderInfo: {},
      orderMemberList: []
    },
    findCouponSendByEvent: [],
    subActivityList: {
      activityList: {
        records: []
      }
    },
    allSubActivityList: {
      activityList: {
        records: []
      }
    },
    subActivityDetails: {},
    subApplyActivity: {
      applyList: {
        records: []
      }
    },
    allSubApplyActivity: {
      applyList: {
        records: []
      }
    },
    chargeLists: [],
    subCouponLogList: {},
    allSubCouponLogList: {},
    subCouponLog: [],
    couponPackages: []
  },
  mutations: {
    QUERY_SINGLE_EXCLUSIVE() {},
    // SAVE_COLLECT_GAME(state, data) {},
    // SAVE_COLLECT_GAME(state) {},
    SAVE_COLLECT_GAME() {},
    //签到设置列表
    QUERY_ACTIVITY_CENTER_LIST(state, data) {
      state.activityCenterList = data.result;
    },
    //签到列表导出
    QUERY_ACTIVITY_CENTER_ALL_LIST(state, data) {
      state.activityCenterAllList = data.result;
    },
    //编辑签到详情
    DETAIL_SIGNIN_ACTIVITY(state, data) {
      state.detailActivity = data.result;
    },
    //编辑签到规则
    EDIT_SIGNIN_ACTIVITY() {},
    //添加签到规则
    ADD_SIGNIN_ACTIVITY() {},
    //我的活动列表
    QUERY_MYACTIVITY_LIST(state, data) {
      state.myActivityList = data.result;
    },
    FILTER_MYACTIVITY_LIST() {},
    //我的活动状态
    QUERY_GAMETYPE_LIST(state, data) {
      state.gameTypeList = data.result;
    },
    //我的活动列表
    QUERY_ALLGAMETYPE_LIST(state, data) {
      state.allGameTypeList = data.result;
    },
    //获奖名单列表
    QUERY_WINNING_LIST(state, data) {
      state.winningList = data.result;
    },
    // 集卡获奖名单列表
    QUERY_COLLECT_CARD_WINNING_LIST(state, data) {
      state.collectCardWinningList = data.result;
    },
    CHANGE_COLLECT_CARD_GAME_PRIZE_STATUS() {},
    // 集卡获奖名单列表
    QUERY_ALL_COLLECT_CARD_WINNING_LIST(state, data) {
      state.allCollectCardWinningList = data.result;
    },
    //获奖名单列表
    QUERY_ALLWINNING_LIST(state, data) {
      state.allWinningList = data.result;
    },
    //创建大转盘活动
    ADD_TURNTABLE(state, data) {
      state.addTurn = data.result;
    },
    //活动详情
    DETAIL_ACTIVIT(state, data) {
      state.detailAct = data.result;
    },
    //编辑活动
    EDIT_ACTIVITY(state, data) {
      state.editAct = data.result;
    },
    //创建特价团活动
    ADD_SPECIAL_ACTIVITY(state, data) {
      state.addSpecial = data.result;
    },
    //特价团活动详情
    DETAILS_SPECIAL_ACTIVITY(state, data) {
      state.detailsSpecial = data.result;
    },
    //编辑特价团活动
    EDIT_SPECIAL_ACTIVITY(state, data) {
      state.editSpecial = data.result;
    },
    //拼团订单列表
    TEAM_ORDER_LIST(state, data) {
      state.teamOrderList = data.result;
    },
    //拼团订单详情
    DETAILS_TEAM_ORDER(state, data) {
      state.detailsTeamOrder = data.result;
    },
    //活动上下线
    UPDATE_ENABLED_STATE(state, data) {
      state.updateEnabledState = data.result;
    },
    //优惠券接口
    FIND_SEND_BY_EVENT(state, data) {
      state.findCouponSendByEvent = data.result;
    },
    //预约活动列表
    SUB_ACTIVITY_LIST(state, data) {
      state.subActivityList = data.result;
      state.subActivityList.activityList.records.forEach(v => {
        v.edit_enddate = true;
      });
    },
    //预约活动列表
    ALL_SUB_ACTIVITY_LIST(state, data) {
      state.allSubActivityList = data.result;
    },
    //新增预约活动
    ADD_SUB_ACTIVITY(state, data) {
      state.addSub = data.result;
    },
    //预约活动详情
    SUB_ACTIVITY_DETAILS(state, data) {
      state.subActivityDetails = data.result;
      // state.subActivityDetails.roundBo.forEach(o => {
      //   o.subscribeRound.reverse();
      // });
    },
    //编辑预约活动
    EDIT_SUB_ACTIVITY(state, data) {
      state.editSubActivity = data.result;
    },
    //删除预约活动
    DEL_SUB_ACTIVITY(state, data) {
      state.delSubActivity = data.result;
    },
    //查看预约列表
    SUB_APPLY_ACTIVITY(state, data) {
      state.subApplyActivity = data.result;
    },
    //导出查看预约列表
    ALL_SUB_APPLY_ACTIVITY(state, data) {
      state.allSubApplyActivity = data.result;
    },
    APPLY_EXPORT() {},
    ALL_COLUMNNAME(state, data) {
      state.allColumn = data.result
    },
    //预约核销
    CHARGE_FROM_ID(state, data) {
      state.chargeFromId = data.result;
    },
    //预约活动核销中心
    CHARGE_LIST(state, data) {
      state.chargeLists = data.result;
    },
    //预约活动核销中心核销
    CHARGE_FROM_CODE(state, data) {
      state.chargeFromCode = data.result;
    },
    //预约活动发券管理
    SUB_COUPONLOG_LIST(state, data) {
      state.subCouponLogList = data.result;
    },
    //导出预约活动发券管理
    ALL_SUB_COUPONLOG_LIST(state, data) {
      state.allSubCouponLogList = data.result;
    },
    SUB_COUPONLOG(state, data) {
      state.subCouponLog = data.result;
    },
    QUERY_COUPON(state, data) {
      state.couponPackages = data.result;
    },
    SAVE_SUB_COUPONLOG(state, data) {
      state.saveSub = data.result;
    },
    DEL_SUB_COUPONLOG(state, data) {
      state.delSubCouponLog = data.result;
    },
    QUERY_COUNT() {},
    QUERT_GAME_TEAM_ORDER_DETAILS() {},
    ADD_STORE_OFFLINE_DRAW_RULE() {},
    CONFIG_QUERY() {},
    STORE_OFFLINE_DRAW_RULE_LIST() {},
    CHECK_DRAW_NAME() {},
    EDIT_STORE_OFFLINE_DRAW_RULE() {},
    QUERY_MY_ACTIVITY_DETAILS() {},
    ADD_ACTIVE_PLAN() {},
    QUERY_ACT_TYPE_LIST() {},
    ADD_ACT_TYPE_DICT() {},
    QUERY_PLAN_TIME_LIST() {},
    QUERY_ACTIVE_PLAN_REL_LIST() {},
    ADD_ACTIVE_PLAN_REL() {},
    REMOVE_ACTIVE_PLAN_REL() {},
    DELETE_ACTIVE_PLAN() {},
    IMPORT_SKU_GOODS_SN() {},
    QUERY_PT_TIP() {},
    QUERY_LC_LIST() {},
    IMPORT_JOIN_LIST() {},
    QUERY_LW_LIST() {},
    MANUAL_OPEN_PRIZE() {},
    QUERY_LC_ALL_LIST() {},
    QUERY_LW_ALL_LIST() {},
    LUCKY_CHARM_WRITE_OFF() {},
    LUCKY_CHARM_RESET() {},
    QUERY_COMMON_ITEMS() {},
    QUERY_FORM_INPUT() {},
    QUERY_ACT_LABEL() {},
    CHANGE_IS_WINNER() {},
    COLLECT_CARD_LIST() {},
    QUERY_SIGN_ACT_DETAILS() {},
    QUERY_SINGLE_ACT_DETAILS() {},
    DEL_SIGNED_ACT_INFO() {},
    QUERY_TURNTABLE_LIST() {},
    QUERY_TURNTABLE_ALL_LIST() {},
    QUERY_TURNTABLE_WINNING_LIST() {},
    QUERY_TURNTABLE_WINNING_ALL_LIST() {},
    QUERY_BARGAIN_ORDER_LIST() {},
    QUERY_BARGAIN_ORDER_DETAILSLIST() {},
    QUERY_PRIZE_NAME() {},
    QUERY_SUBAPPLY_ORDER_LIST() {},
    SUBAPPLY_REFUND() {},
    SUBAPPLY_ORDER_EXPORT() {},
    FIND_STORE_GAME_DATA() {},
    FIND_STORE_GAME_NAME_DATA() {},
    QUERY_GAME_DATA_BOAED() {},
    QUERY_GAME_DATA_TOTAL_ECHARTS() {},
    QUERY_OFFLINE_DRAW_UIREL() {},
    SAVE_OFFLINE_DRAW_UIREL() {},
    QUERY_DRAW_RECORD_LIST() {},
    QUERY_SINGLE_ACT_JIELONG() {},
    QUERY_SINGLE_ACT_FINDTAG() {},
    QUERY_SINGLE_ACT_ADDTAG() {},
    QUERY_SINGLE_ACT_JILLONGINFOLIST() {},
    QUERY_SINGLE_ACT_JILLONGFINDGAMEBYID() {},
    QUERY_SINGLE_ACT_JILLONGOPERATION() {},
    QUERY_SINGLE_ACT_JIELONGEDITGAME() {},
    SHARE_DATA_SAVE() {},
    SHARE_DATA_SAVE_V2() {},
    QUERY_SINGLE_ACT_JIELONGGETDETAILLIST() {},
    QUERY_SINGLE_ACT_JIELONGGOODSLIST() {},
    QUERY_SINGLE_ACT_JIELONGOERATION() {},
    QUERY_SINGLE_ACT_JIELONGSAVE() {},
    EDIT_SORT_NUMBER() {},
    UPDATE_TURN_TABLE_PRIZE_NUM() {},
    QUERY_GAME_DATA_ANALYSE() {},
    QUERY_GAME_DATA_ANALYSE_PATH() {},
    PHYSIOLOGICAL_DATA_EXPORT() {},
    SAVE_GAME_INFO() {},
    QUERY_HOT_SALE_GAME_LIST(){},
    CANCEL_APPLY(){},
    QUERY_RED_ENVELOPE_RAIN_JOIN_PAGE_LIST() {},
    QUERY_RED_ENVELOPE_RAIN_WINNING_PAGE_LIST() {},
    QUERY_BARGAIN_TICKET_EXCHANGE_RECORD_LIST() {},
    QUERY_JIELONG_DYNAMIC_FORM() {},
    WXSHOP_SPU_INTEGRAL_TYPE_INFO_ADD() {},
    WXSHOP_SPU_INTEGRAL_TYPE_INFO_EDit() {},
    WXSHOP_SPU_INTEGRAL_TYPE_INFO_DELETE() {},
    WXSHOP_SPU_INTEGRAL_TYPE_INFO_QUERY_BY_ID() {},
    WXSHOP_SPU_INTEGRAL_TYPE_INFO_LIST() {},
    FISSION_RECORD() {},
    PAS_APPLY_CANCEL() {},
    PAS_APPLY_COMPLETE() {},
    IMPORT_FILTER_SHOP_CODE_LIST(){},
  },
  actions: {
    // 接龙修改保存
    saveJielongGoods({ commit }, params) {
      return post({
        commit,
        url: `/game/saveJielongGoods`,
        name: "QUERY_SINGLE_ACT_JIELONGSAVE",
        params
      });
    },
    // 接龙商品 删除和恢复
    changeGoodsAddlList({ commit }, params) {
      return post({
        commit,
        url: `/game/operationJielongGoods`,
        name: "QUERY_SINGLE_ACT_JIELONGOERATION",
        params
      });
    },
    // 接龙商品新增
    getGoodsAddlList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryJielongGoodsList`,
        name: "QUERY_SINGLE_ACT_JIELONGGOODSLIST",
        params
      });
    },
    // 查询接龙活动商品
    getGoodsDetailList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryJielongGoodsList`,
        name: "QUERY_SINGLE_ACT_JIELONGGOODSLIST",
        params
      });
    },
    // 删除团,隐藏团,上线,下线
    getOrderDetailList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryJielongOrderList`,
        name: "QUERY_SINGLE_ACT_JIELONGGETDETAILLIST",
        params
      });
    },
    // 删除团,隐藏团,上线,下线
    operationjieLong({ commit }, params) {
      return post({
        commit,
        url: `/game/operationJielongInfo`,
        name: "QUERY_SINGLE_ACT_JILLONGOPERATION",
        params
      });
    },
    
    // 查询接龙详情
    findJieLongInfoById({ commit }, params) {
      return post({
        commit,
        url: `/game/findGameInfoById`,
        name: "QUERY_SINGLE_ACT_JILLONGFINDGAMEBYID",
        params
      });
    },
    //  接龙---查询活动列表
    findJieLongList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryJielongInfoList`,
        name: "QUERY_SINGLE_ACT_JILLONGINFOLIST",
        params
      });
    },
    //  接龙---新增标签
    addJieLongTag({ commit }, params) {
      return post({
        commit,
        url: `/game/saveActivityLabelInfo`,
        name: "QUERY_SINGLE_ACT_ADDTAG",
        params
      });
    },
    // 接龙--查询标签
    findJieLongTag({ commit }, params) {
      return post({
        commit,
        url: `/game/queryActivityLabelInfoList`,
        name: "QUERY_SINGLE_ACT_FINDTAG",
        params
      });
    },
    // 接龙 修改
    editGameInfoJieLong({ commit }, params) {
      return post({
        commit,
        url: `/game/editGameInfo`,
        name: "QUERY_SINGLE_ACT_JIELONGEDITGAME",
        params
      });
    },
    // 接龙 新增和复制
    saveGameInfoJieLong({ commit }, params) {
      return post({
        commit,
        url: `/game/saveGameInfo`,
        name: "QUERY_SINGLE_ACT_JIELONG",
        params
      });
    },
    querySingleSignActDetails({ commit }, params) {
      return post({
        commit,
        url: `/signed/hmSignedActivityInfo/findSignedActivityInfoMemberSignedList`,
        name: "QUERY_SINGLE_ACT_DETAILS",
        params
      });
    },
    querySignActDetails({ commit }, params) {
      return post({
        commit,
        url: `/signed/hmSignedActivityInfo/findSignedActivityInfoMemberList`,
        name: "QUERY_SIGN_ACT_DETAILS",
        params
      });
    },
    changeCollectCardGamePrizeStatus({ commit }, params) {
      return post({
        commit,
        url: `/game/updateSendStatus`,
        name: "CHANGE_COLLECT_CARD_GAME_PRIZE_STATUS",
        params
      });
    },
    saveCollectGame({ commit }, params) {
      return post({
        commit,
        url: `/game/saveGameInfo`,
        name: "SAVE_COLLECT_GAME",
        params
      });
    },
    //签到设置列表
    queryActivityCenterList({ commit }, params) {
      return post({
        commit,
        url: `/signed/hmSignedActivityInfo/findSignedActivityList`,
        name: "QUERY_ACTIVITY_CENTER_LIST",
        params
      });
    },

    //添加签到规则
    addSignInActivity({ commit }, params) {
      return post({
        commit,
        url: `/signed/hmSignedActivityInfo/saveSignedActivityInfo`,
        name: "ADD_SIGNIN_ACTIVITY",
        params
      });
    },

    //签到列表导出
    queryActivityCenterAllList({ commit }, params) {
      return post({
        commit,
        url: `/signed/hmSignedActivityInfo/findSignedActivityList`,
        name: "QUERY_ACTIVITY_CENTER_ALL_LIST",
        params
      });
    },
    //编辑签到详情
    detailSignInActivity({ commit }, params) {
      return post({
        commit,
        url: `/signed/hmSignedActivityInfo/findSignedActivityInfoById`,
        name: "DETAIL_SIGNIN_ACTIVITY",
        params
      });
    },
    //编辑签到详情
    editSignInActivity({ commit }, params) {
      return post({
        commit,
        url: `/signed/hmSignedActivityInfo/editSignedActivityInfo`,
        name: "EDIT_SIGNIN_ACTIVITY",
        params
      });
    },
    //我的活动列表
    queryMyActivityList({ commit }, params) {
      return post({
        commit,
        url: `/game/findGameList`,
        name: "QUERY_MYACTIVITY_LIST",
        params
      });
    },
    // 店铺装修使用
    filterMyActivityList({ commit }, params) {
      return post({
        commit,
        url: `/game/findGameList`,
        name: "FILTER_MYACTIVITY_LIST",
        params
      });
    },
    // 店铺装修-热销活动列表
    queryHotSaleGameList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryHotSaleGameList`,
        name: "QUERY_HOT_SALE_GAME_LIST",
        params
      });
    },
    queryMyActivityDetails({ commit }, params) {
      return post({
        commit,
        url: `/game/goods_list`,
        name: "QUERY_MY_ACTIVITY_DETAILS",
        params
      });
    },
    querySingleExclusiveActivityDetails({ commit }, params) {
      return post({
        commit,
        url: `/game/small/querySingleSingleExclusiveGoodsList`,
        name: "QUERY_SINGLE_EXCLUSIVE",
        params
      });
    },
    //我的活动状态
    queryGameTypeList({ commit }, params) {
      return post({
        commit,
        url: `/game/findStoreGame`,
        name: "QUERY_GAMETYPE_LIST",
        params
      });
    },
    //我的活动列表
    queryAllMyActivityList({ commit }, params) {
      return post({
        commit,
        url: `/game/findGameList`,
        name: "QUERY_ALLGAMETYPE_LIST",
        params
      });
    },
    //获奖名单列表
    queryWinningList({ commit }, params) {
      return post({
        commit,
        url: `/game/findGameWinningList`,
        name: "QUERY_WINNING_LIST",
        params
      });
    },
    //集卡获奖名单列表
    queryCollectCardWinningList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryComposeRecordPageList`,
        name: "QUERY_COLLECT_CARD_WINNING_LIST",
        params
      });
    },
    //获奖名单列表
    queryAllWinningList({ commit }, params) {
      return post({
        commit,
        url: `/game/findGameWinningList`,
        name: "QUERY_ALLWINNING_LIST",
        params
      });
    },
    queryAllCollectCardWinningList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryComposeRecordPageList`,
        name: "QUERY_ALL_COLLECT_CARD_WINNING_LIST",
        params
      });
    },
    //创建大转盘活动
    addTurntable({ commit }, params) {
      return post({
        commit,
        url: `/game/saveGameInfo`,
        name: "ADD_TURNTABLE",
        params
      });
    },
    queryCollectCardList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryCollectCardChipInfoList`,
        name: "COLLECT_CARD_LIST",
        params
      });
    },
    //活动详情
    importFilterShopCodeList({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/store/storeShopInfo/importFilterShopCodeList`,
        name: "IMPORT_FILTER_SHOP_CODE_LIST",
        params
      });
    },
    //活动详情
    queryActivitDetail({ commit }, params) {
      return post({
        commit,
        url: `/game/findGameInfoById`,
        name: "DETAIL_ACTIVIT",
        params
      });
    },
    //编辑活动
    editActivity({ commit }, params) {
      return post({
        commit,
        url: `/game/editGameInfo`,
        name: "EDIT_ACTIVITY",
        params
      });
    },
    //创建特价团活动
    addSpecialAct({ commit }, params) {
      return post({
        commit,
        url: `/gameTeam/saveGameTeam`,
        name: "ADD_SPECIAL_ACTIVITY",
        params
      });
    },
    //特价团活动详情
    detailsSpecialAct({ commit }, params) {
      return post({
        commit,
        url: `/gameTeam/findGameTeamById`,
        name: "DETAILS_SPECIAL_ACTIVITY",
        params
      });
    },
    //编辑特价团活动
    editSpecialAct({ commit }, params) {
      return post({
        commit,
        url: `/gameTeam/editGameTeamInfo`,
        name: "EDIT_SPECIAL_ACTIVITY",
        params
      });
    },
    //拼团订单列表
    teamOrderList({ commit }, params) {
      return post({
        commit,
        url: `/gameTeam/findGameTeamOrderList`,
        name: "TEAM_ORDER_LIST",
        params
      });
    },
    //拼团订单详情
    detailsTeamOrder({ commit }, params) {
      return post({
        commit,
        url: `/gameTeam/findGameTeamOrderBySn`,
        name: "DETAILS_TEAM_ORDER",
        params
      });
    },
    //活动上下线
    updateEnabled({ commit }, params) {
      return post({
        commit,
        url: `/game/updateEnabledState`,
        name: "UPDATE_ENABLED_STATE",
        params
      });
    },
    //优惠券接口
    findCouponSendByEvent({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/findCouponSendByEvent`,
        name: "FIND_SEND_BY_EVENT",
        params
      });
    },
    //预约活动列表
    subActivityList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeActivity/sub_activity_list`,
        name: "SUB_ACTIVITY_LIST",
        params
      });
    },
    //导出预约活动列表
    allSubActivityList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeActivity/sub_activity_list`,
        name: "ALL_SUB_ACTIVITY_LIST",
        params
      });
    },
    //新增预约活动
    addSubActivity({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeActivity/add_activity`,
        name: "ADD_SUB_ACTIVITY",
        params
      });
    },
    //预约活动详情
    subActivityDetails({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeActivity/sub_activity_detail`,
        name: "SUB_ACTIVITY_DETAILS",
        params
      });
    },
    //编辑预约活动
    editSubActivity({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeActivity/update_activity`,
        name: "EDIT_SUB_ACTIVITY",
        params
      });
    },
    //删除预约活动
    delSubActivity({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeActivity/del_activity`,
        name: "DEL_SUB_ACTIVITY",
        params
      });
    },
    //查看预约列表
    subApplyActivity({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeApply/sub_apply_detail`,
        name: "SUB_APPLY_ACTIVITY",
        params
      });
    },
    //导出查看预约列表
    allSubApplyActivity({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeApply/sub_apply_detail`,
        name: "ALL_SUB_APPLY_ACTIVITY",
        params
      });
    },
    // 导出
    getSubscribeApplyDetailListExport({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeApply/getSubscribeApplyDetailListExport`,
        name: "APPLY_EXPORT",
        params
      });
    },
    //导出查看预约列表表单所有label
    allColumnName({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeApply/sub_apply_all_columnName`,
        name: "ALL_COLUMNNAME",
        params
      });
    },
    //预约核销
    chargeFromId({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeApply/do_charge_by_id`,
        name: "CHARGE_FROM_ID",
        params
      });
    },
    //预约活动核销中心
    chargeList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeApply/get_charge_list`,
        name: "CHARGE_LIST",
        params
      });
    },
    //预约活动核销中心核销
    chargeFromCode({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeApply/do_charge_by_authCode`,
        name: "CHARGE_FROM_CODE",
        params
      });
    },
    //预约活动发券管理
    subCouponLogList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeCouponLog/sub_couponLog_list`,
        name: "SUB_COUPONLOG_LIST",
        params
      });
    },
    //导出预约活动发券管理
    allSubCouponLogList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeCouponLog/sub_couponLog_list`,
        name: "ALL_SUB_COUPONLOG_LIST",
        params
      });
    },
    addSubCouponLogs({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeCouponLog/add_sub_couponLog`,
        name: "SUB_COUPONLOG",
        params
      });
    },
    queryCouponPackages({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeCouponLog/query_coupon_list`,
        name: "QUERY_COUPON",
        params
      });
    },
    saveSendCouponPackages({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeCouponLog/save_sub_couponLog`,
        name: "SAVE_SUB_COUPONLOG",
        params
      });
    },
    delSubCouponLog({ commit }, params) {
      return post({
        commit,
        url: `/promotion/subscribeCouponLog/del_sub_couponLog`,
        name: "DEL_SUB_COUPONLOG",
        params
      });
    },
    querySignedActivityTimeTypeCount({ commit }, params) {
      return post({
        commit,
        url: `/signed/hmSignedActivityInfo/findSignedActivityTimeTypeCount`,
        name: "QUERY_COUNT",
        params
      });
    },
    queryGameTeamOrderDetails({ commit }, params) {
      return post({
        commit,
        url: `/gameTeam/exportGameTeamOrderDetails`,
        name: "QUERT_GAME_TEAM_ORDER_DETAILS",
        params
      });
    },
    addStoreOfflineDrawRule({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/add`,
        name: "ADD_STORE_OFFLINE_DRAW_RULE",
        params
      });
    },
    configQuery({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/query`,
        name: "CONFIG_QUERY",
        params
      });
    },
    storeOfflineDrawRuleList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/list`,
        name: "STORE_OFFLINE_DRAW_RULE_LIST",
        params
      });
    },
    checkDrawName({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/checkDrawName`,
        name: "CHECK_DRAW_NAME",
        params
      });
    },
    editStoreOfflineDrawRule({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/edit`,
        name: "EDIT_STORE_OFFLINE_DRAW_RULE",
        params
      });
    },
    addActivePlan({ commit }, params) {
      return post({
        commit,
        url: `/store/back/active_plan/add`,
        name: "ADD_ACTIVE_PLAN",
        params
      });
    },
    queryActTypeList({ commit }, params) {
      return post({
        commit,
        url: `/store/dict/item/list`,
        name: "QUERY_ACT_TYPE_LIST",
        params
      });
    },
    addActTypeDict({ commit }, params) {
      return post({
        commit,
        url: `/store/dict/item/batch_add`,
        name: "ADD_ACT_TYPE_DICT",
        params
      });
    },
    queryPlanTimeList({ commit }, params) {
      return post({
        commit,
        url: `/store/back/active_plan/query`,
        name: "QUERY_PLAN_TIME_LIST",
        params
      });
    },
    queryActivePlanRelList({ commit }, params) {
      return post({
        commit,
        url: `/store/back/active_plan/rel_list`,
        name: "QUERY_ACTIVE_PLAN_REL_LIST",
        params
      });
    },
    addActivePlanRel({ commit }, params) {
      return post({
        commit,
        url: `/store/back/active_plan/rel_add`,
        name: "ADD_ACTIVE_PLAN_REL",
        params
      });
    },
    removActivePlanRel({ commit }, params) {
      return post({
        commit,
        url: `/store/back/active_plan/rel_remove`,
        name: "REMOVE_ACTIVE_PLAN_REL",
        params
      });
    },
    deleteActivePlan({ commit }, params) {
      return post({
        commit,
        url: `/store/back/active_plan/delete`,
        name: "DELETE_ACTIVE_PLAN",
        params
      });
    },
    queryWxshopSkuByGoodsSn({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/queryWxshopSkuByGoodsSn`,
        name: "IMPORT_SKU_GOODS_SN",
        params
      });
    },
    queryPtTip({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/getUiPopoverByPopoverCode?popoverCode=pt_tip`,
        name: "QUERY_PT_TIP",
        params
      });
    },
    queryLuckyCharmlist({ commit }, params) {
      return post({
        commit,
        url: `/game/find_lucky_charm_join_list`,
        name: "QUERY_LC_LIST",
        params
      });
    },
    queryTimedCharmlist({ commit }, params) {
      return post({
        commit,
        url: `/game/small/timed_charm_join_info`,
        name: "QUERY_LC_LIST",
        params
      });
    },
    queryLuckyCharmAlllist({ commit }, params) {
      return post({
        commit,
        url: `/game/find_lucky_charm_join_list`,
        name: "QUERY_LC_ALL_LIST",
        params
      });
    },
    importJoinList({ commit }, params) {
      return post({
        commit,
        url: `/game/import_join_list`,
        name: "IMPORT_JOIN_LIST",
        params
      });
    },
    queryLuckyWinnerlist({ commit }, params) {
      return post({
        commit,
        url: `/game/find_lucky_winner_list`,
        name: "QUERY_LW_LIST",
        params
      });
    },
    queryLuckyWinnerAlllist({ commit }, params) {
      return post({
        commit,
        url: `/game/find_lucky_winner_list`,
        name: "QUERY_LW_ALL_LIST",
        params
      });
    },
    manualOpenPrize({ commit }, params) {
      return post({
        commit,
        url: `/game/manual_open_prize`,
        name: "MANUAL_OPEN_PRIZE",
        params
      });
    },
    luckyCharmWriteOff({ commit }, params) {
      return post({
        commit,
        url: `/game/lucky_charm_write_off`,
        name: "LUCKY_CHARM_WRITE_OFF",
        params
      });
    },
    luckyCharmReset({ commit }, params) {
      return post({
        commit,
        url: `/game/lucky_charm_reset`,
        name: "LUCKY_CHARM_RESET",
        params
      });
    },
    queryCommonItems({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeActivity/queryCommonItems`,
        name: "QUERY_COMMON_ITEMS",
        params
      });
    },
    queryDynamicFormInputRecord({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeActivity/queryDynamicFormInputRecord`,
        name: "QUERY_FORM_INPUT",
        params
      });
    },
    queryActivityLabel({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeActivity/queryActivityLabel`,
        name: "QUERY_ACT_LABEL",
        params
      });
    },
    changeIsWinner({ commit }, params) {
      return post({
        commit,
        url: `/game/batch_change_is_winner`,
        name: "CHANGE_IS_WINNER",
        params
      });
    },
    delSignedActivityInfo({ commit }, params) {
      return post({
        commit,
        url: `/signed/hmSignedActivityInfo/delSignedActivityInfo`,
        name: "DEL_SIGNED_ACT_INFO",
        params
      });
    },
    queryTurntableLuckyDrawJoinList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryTurntableLuckyDrawJoinList`,
        name: "QUERY_TURNTABLE_LIST",
        params
      });
    },
    queryTurntableLuckyDrawJoinAllList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryTurntableLuckyDrawJoinList`,
        name: "QUERY_TURNTABLE_ALL_LIST",
        params
      });
    },
    queryTurntableLuckyDrawWinningList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryTurntableLuckyDrawWinningList`,
        name: "QUERY_TURNTABLE_WINNING_LIST",
        params
      });
    },
    queryTurntableLuckyDrawWinningAllList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryTurntableLuckyDrawWinningList`,
        name: "QUERY_TURNTABLE_WINNING_ALL_LIST",
        params
      });
    },
    queryBargainDetail({ commit }, params) {
      return post({
        commit,
        url: `/game/bargain_order_list`,
        name: "QUERY_BARGAIN_ORDER_LIST",
        params
      });
    },
    queryBargainOrderDetail({ commit }, params) {
      return post({
        commit,
        url: `/game/bargain_order_detail`,
        name: "QUERY_BARGAIN_ORDER_DETAILSLIST",
        params
      });
    },
    queryPrizeName({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/queryPrizeName`,
        name: "QUERY_PRIZE_NAME",
        params
      });
    },
    querySubApplyOrderList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeApply/querySubApplyOrderList`,
        name: "QUERY_SUBAPPLY_ORDER_LIST",
        params
      });
    },
    subApplyRefund({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeApply/subApplyRefund`,
        name: "SUBAPPLY_REFUND",
        params
      });
    },
    subApplyOrderListExport({ commit }, params) {
      return post({
        commit,
        url: `/reports/daystatOrderDetails/subApplyOrderListExport?false`,
        name: "SUBAPPLY_ORDER_EXPORT",
        params
      });
    },
    findStoreGameToGameData({ commit }, params) {
      return post({
        commit,
        url: `/gameData/findStoreGameToGameData`,
        name: "FIND_STORE_GAME_DATA",
        params
      });
    },
    findStoreGameInfoToGameData({ commit }, params) {
      return post({
        commit,
        url: `/gameData/findStoreGameInfoToGameData`,
        name: "FIND_STORE_GAME_NAME_DATA",
        params
      });
    },
    queryGameDataBoard({ commit }, params) {
      return post({
        commit,
        url: `/gameData/queryGameDataBoard`,
        name: "QUERY_GAME_DATA_BOAED",
        params
      });
    },
    queryGameDataTotalEcharts({ commit }, params) {
      return post({
        commit,
        url: `/gameData/queryGameDataTotalEcharts`,
        name: "QUERY_GAME_DATA_TOTAL_ECHARTS",
        params
      });
    },
    queryOfflineDrawUiRel({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/queryOfflineDrawUiRel`,
        name: "QUERY_OFFLINE_DRAW_UIREL",
        params
      });
    },
    saveOfflineDrawUiRel({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/saveOfflineDrawUiRel`,
        name: "SAVE_OFFLINE_DRAW_UIREL",
        params
      });
    },
    queryDrawRecordList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/queryDrawRecordList`,
        name: "QUERY_DRAW_RECORD_LIST",
        params
      });
    },
    shareDataSave({ commit }, params) {
      return post({
        commit,
        url: `/mobile_mall/share_data_save`,
        name: "SHARE_DATA_SAVE",
        params
      });
    },
    shareDataSaveV2({ commit }, params) {
      return post({
        commit,
        url: `/mobile_mall/share_data_save/v2.0`,
        name: "SHARE_DATA_SAVE_V2",
        params
      });
    },
    editSortNum({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeActivity/editSortNum`,
        name: "EDIT_SORT_NUMBER",
        params
      });
    },
    updateTurntablePrizeNum({ commit }, params) {
      return post({
        commit,
        url: `/game/updateTurntablePrizeNum`,
        name: "UPDATE_TURN_TABLE_PRIZE_NUM",
        params
      });
    },
    queryGameDataAnalyse({ commit }, params) {
      return post({
        commit,
        url: `/gameData/queryGameDataToDataAnalyse`,
        name: "QUERY_GAME_DATA_ANALYSE",
        params
      });
    },
    queryGameDataAnalysePath({ commit }, params) {
      return post({
        commit,
        url: `/gameData/queryGameDataToPathFrom`,
        name: "QUERY_GAME_DATA_ANALYSE_PATH",
        params
      });
    },
    physiologicalDataExport({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/physiologicalDataExport`,
        name: "PHYSIOLOGICAL_DATA_EXPORT",
        params
      });
    },
    //创建省钱卡活动
    saveGameInfo({ commit }, params) {
      return post({
        commit,
        url: `/game/saveGameInfo`,
        name: "SAVE_GAME_INFO",
        params
      });
    },
    cancelApply({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeApply/cancelApply`,
        name: "CANCEL_APPLY",
        params
      });
    },
    pasApplyCancel({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/declare/pas/pas_apply_cancel`,
        name: "PAS_APPLY_CANCEL",
        params
      });
    },
    pasApplyComplete({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/declare/pas/pas_apply_complete `,
        name: "PAS_APPLY_COMPLETE",
        params
      });
    },
    queryRedEnvelopeRainJoinPageList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryRedEnvelopeRainJoinPageList`,
        name: "QUERY_RED_ENVELOPE_RAIN_JOIN_PAGE_LIST",
        params
      });
    },
    queryRedEnvelopeRainWinningPageList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryRedEnvelopeRainWinningPageList`,
        name: "QUERY_RED_ENVELOPE_RAIN_WINNING_PAGE_LIST",
        params
      });
    },
    queryExchangeRecordList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryBargainTicketExchangeRecordList`,
        name: "QUERY_BARGAIN_TICKET_EXCHANGE_RECORD_LIST",
        params
      });
    },
    queryJielongDynamicForm({ commit }, params) {
      return post({
        commit,
        url: `/game/queryJielongDynamicForm`,
        name: "QUERY_JIELONG_DYNAMIC_FORM",
        params
      });
    },
    //新增积分类型
    wxshopSpuIntegralTypeInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/wxshopSpu/wxshopSpuIntegralTypeInfo/add`,
        name: "WXSHOP_SPU_INTEGRAL_TYPE_INFO_ADD",
        params
      });
    },
    //编辑积分类型
    wxshopSpuIntegralTypeInfoEdit({ commit }, params) {
      return post({
        commit,
        url: `/wxshopSpu/wxshopSpuIntegralTypeInfo/edit`,
        name: "WXSHOP_SPU_INTEGRAL_TYPE_INFO_EDIT",
        params
      });
    },
    //删除积分类型
    wxshopSpuIntegralTypeInfoDelete({ commit }, params) {
      return post({
        commit,
        url: `/wxshopSpu/wxshopSpuIntegralTypeInfo/delete`,
        name: "WXSHOP_SPU_INTEGRAL_TYPE_INFO_DELETE",
        params
      });
    },
    //查询单个积分类型
    wxshopSpuIntegralTypeInfoQueryById({ commit }, params) {
      return post({
        commit,
        url: `/wxshopSpu/wxshopSpuIntegralTypeInfo/queryById`,
        name: "WXSHOP_SPU_INTEGRAL_TYPE_INFO_QUERY_BY_ID",
        params
      });
    },
    //积分类型列表
    wxshopSpuIntegralTypeInfoList({ commit }, params) {
      return post({
        commit,
        url: `/wxshopSpu/wxshopSpuIntegralTypeInfo/queryPageList`,
        name: "WXSHOP_SPU_INTEGRAL_TYPE_INFO_LIST",
        params
      });
    },
    fissionRecord({ commit }, params) {
      return post({
        commit,
        url: `/game/fission/record`,
        name: "FISSION_RECORD",
        params
      });
    },
    fissionRecordInvite({ commit }, params) {
      return post({
        commit,
        url: `/game/fission/record/invite`,
        name: "FISSION_RECORD",
        params
      });
    },
  }
};

export default activityCenter;
